import { type Clinic, getRegionDefaultClinic } from '@snootsvet/shared'

import { useViewerRegion } from '@/frontend/features/region/region-context'
import { useUserSettings } from '@/frontend/hooks/use-user-settings'

type DefaultClinicResult =
  | { isLoading: true; clinic?: never }
  | { isLoading: false; clinic: Clinic }

export function useDefaultClinic(): DefaultClinicResult {
  const { settings } = useUserSettings()
  const { region, isLoading } = useViewerRegion()
  if (isLoading || !settings) return { isLoading: true }

  const preferred = settings.defaultClinic
  return {
    isLoading: false,
    clinic: preferred?.region === region ? preferred : getRegionDefaultClinic(region),
  }
}
